import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError(error => {
      // Skip Cognito IDP requests
      const cognitoUrl = `https://cognito-idp.${environment.cognito.region}.amazonaws.com/`;
      if (req.url.startsWith(cognitoUrl)) {
        return throwError(() => error);
      }

      if (error.status === 401) {
        return authService.refreshSession().pipe(
          switchMap(() => {
            const token = authService.getIdToken();
            const retryReq = req.clone({
              setHeaders: { Authorization: `Bearer ${token}` },
            });
            return next(retryReq);
          }),
          catchError(() => {
            authService.logout();
            return throwError(() => error);
          })
        );
      }

      return throwError(() => error);
    })
  );
};
